/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDomainsLimitOutput
 */
export interface ProjectDomainsLimitOutput {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDomainsLimitOutput
     */
    hasEffectivePackage?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainsLimitOutput
     */
    effectiveMaxDomains?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainsLimitOutput
     */
    effectivePackageCode?: string | null;
}

/**
 * Check if a given object implements the ProjectDomainsLimitOutput interface.
 */
export function instanceOfProjectDomainsLimitOutput(value: object): value is ProjectDomainsLimitOutput {
    return true;
}

export function ProjectDomainsLimitOutputFromJSON(json: any): ProjectDomainsLimitOutput {
    return ProjectDomainsLimitOutputFromJSONTyped(json, false);
}

export function ProjectDomainsLimitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainsLimitOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'hasEffectivePackage': json['hasEffectivePackage'] == null ? undefined : json['hasEffectivePackage'],
        'effectiveMaxDomains': json['effectiveMaxDomains'] == null ? undefined : json['effectiveMaxDomains'],
        'effectivePackageCode': json['effectivePackageCode'] === undefined ? undefined : json['effectivePackageCode'] === null ? null : json['effectivePackageCode'],
    };
}

export function ProjectDomainsLimitOutputToJSON(json: any): ProjectDomainsLimitOutput {
    return ProjectDomainsLimitOutputToJSONTyped(json, false);
}

export function ProjectDomainsLimitOutputToJSONTyped(value?: ProjectDomainsLimitOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasEffectivePackage': value['hasEffectivePackage'],
        'effectiveMaxDomains': value['effectiveMaxDomains'],
        'effectivePackageCode': value['effectivePackageCode'],
    };
}

